export { default } from './EmptyContentPanel';



// WEBPACK FOOTER //
// ./app/components/shared/EmptyContentPanel/index.js